export const hasRouteValue = (value) => ![null, undefined, ""].includes(value);

export const normalizeUrlValue = (value) => {
  if (typeof value !== "string") {
    return null;
  }

  const trimmedValue = value.trim();

  if (["", "null", "undefined"].includes(trimmedValue.toLowerCase())) {
    return null;
  }

  return trimmedValue;
};

export const appendCacheBust = (value, token) => {
  const normalizedValue = normalizeUrlValue(value);

  if (!normalizedValue) {
    return null;
  }

  const separator = normalizedValue.includes("?") ? "&" : "?";

  return `${normalizedValue}${separator}${token}`;
};

export const normalizeRouteParams = (params) => {
  if (!hasRouteValue(params)) {
    return undefined;
  }

  if (Array.isArray(params)) {
    const filteredParams = params.filter((value) => hasRouteValue(value));

    return filteredParams.length > 0 ? filteredParams : undefined;
  }

  if (typeof params === "object") {
    const filteredParams = Object.fromEntries(Object.entries(params).filter(([, value]) => hasRouteValue(value)));

    return Object.keys(filteredParams).length > 0 ? filteredParams : undefined;
  }

  return params;
};
